import { useStoreon } from 'storeon/react';
import { ContentBrands } from 'types/sponsored-brands';

interface BannerItem extends ContentBrands {}

interface UseSponsoredBrandsResult {
  itemsToDisplay: Array<BannerItem>;
}

export const useSponsoredBrands = (): UseSponsoredBrandsResult => {
  const { sponsoredBrands } = useStoreon('sponsoredBrands');

  const itemsToDisplay = Array.isArray(sponsoredBrands?.brands?.content)
    ? sponsoredBrands.brands.content.slice(0, 3)
    : [];

  return { itemsToDisplay };
};
